import React, { useState, useEffect } from "react";
import {
    Button,
    Card, Collapse, Grid, Paper, Typography,
    Switch
} from "@material-ui/core";
import useStyles from "./styles";

import { InputBaseField, CheckboxField, TextareaField } from '../../components/InputField/InputField';
import { Label } from '../../components/UiElements/UiElements';
import { GetUserInfo } from "../../Services/GetUserInfo";
import { PostDataAPI } from '../../Services/APIService';
import Loader from './../../components/Loader/Loader';

import { withSnackbar } from "./../../components/Message/Alert";


function AccountSettings({ ...props }) {
    const classes = useStyles();
    const { showMessage } = props;

    const [isLoading, setIsLoading] = useState(false);
    const handleChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    };
    const handleInputChange = (event) => {
        //if (event.target.value)
        //   setState({ ...state, [event.target.name]: parseInt(event.target.value) });
        const { name, value } = event.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    };
    let user_info = JSON.parse(GetUserInfo());
    const [customerID] = useState(user_info.user.customerID);
    const [state, setState] = React.useState({
        customerID: parseInt(user_info.user.customerID),
        sendNotifications: false,
        sendExpiryReminders: false,
        sendNewOffers: false,
        usageMonths: 4,
        reminderDays: 5,

    });
    const [customerRecord, setCustomerRecord] = React.useState({});
    const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const isNumber = /\d/.test(keyValue);
        const isSpecialChar = /[^a-zA-Z0-9]/.test(keyValue);
        if (!isNumber || isSpecialChar) {
            event.preventDefault();
        }
    }
    const getCustomerSetting = () => {
        var obj = { customerID: customerID };
        setIsLoading(true);
        PostDataAPI("customer/getCustomer", customerID).then((result) => {

            if (result.success && result.data != null) {
                result.data.usageMonths = 4;
                setState(result.data);
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        });
    }
    const updateCustomerSetting = () => {
        //setIsLoading(true);
        //state.usageMonths = 4;
        //if (state.reminderDays) {
        //    state.reminderDays = parseInt(state.reminderDays);
        //} else {
        //    state.reminderDays = 0;
        //}
        //if (state.daysBeforeDeactivation) {
        //    state.daysBeforeDeactivation = parseInt(state.daysBeforeDeactivation);
        //} else {
        //    state.daysBeforeDeactivation = 0;
        //}
        // state.accountPhoneNumber=customerRecord.accountPhoneNumber;
        //PostDataAPI("customer/updateProfile", state).then((result) => {
        //   
        //    if (result.success && result.data != null) {
        //       
        //        //setState(result.data);
        //        showMessage("Success", "Account settings updated successfully", "success", 3000);
        //    }
        //    else {
        //        showMessage("Error", result.message, "error", 3000);
        //    }
        //    setIsLoading(false);
        //});
    }
    const getCustomerProfileDetails = () => {

        var obj = { customerId: customerID };
        setIsLoading(true);
        PostDataAPI("telispire/getCustomerProfileDetail", obj, true).then((result) => {
            if (result.success && result.data != null) {
                //result.data.objCustomerInfo.workPhone = formateMdnNumber(result.data.objCustomerInfo.workPhone);
                //result.data.objCustomerInfo.homePhone = formateMdnNumber(result.data.objCustomerInfo.homePhone);
                //result.data.objCustomerInfo.shipPhone = formateMdnNumber(result.data.objCustomerInfo.shipPhone);
                //result.data.objCustomerInfo.billingPhone = formateMdnNumber(result.data.objCustomerInfo.billingPhone);
                setCustomerRecord(result.data.objCustomerInfo);
                //if (result.data.objCustomerInfo.creditCardExpiration) {
                //    var expiryDate = result.data.objCustomerInfo.creditCardExpiration.split('/');
                //    result.data.objCustomerInfo.ccExpMonth = expiryDate[0];
                //    result.data.objCustomerInfo.cc = expiryDate[1];
                //}

                //setState(result.data.objCustomerInfo);
                //console.log(result.data)
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        });
    }
    useEffect(() => {
        //getCustomerSetting();
        //getCustomerProfileDetails();
    }, []);
    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <div className={classes.appBarSpacer} />
            <div className={classes.header}>
                <Typography component="h2">Account Settings</Typography>
            </div>
            <Grid className={classes.container}>

                <Grid container className={classes.settingContainer}>
                    <h3>Reminders and Notification (Email/SMS)</h3>

                    <Grid container className={classes.settingOptions}>
                        <Grid md={6} lg={6} sm={6}>
                            <p>Send important notification and updates</p>
                        </Grid>
                        <Grid md={6} lg={6} sm={6} className="align-right">
                            <Switch
                                disabled={true}
                                checked={state.sendNotifications ? state.sendNotifications : true}
                                onChange={handleChange}
                                name="sendNotifications"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                classes={{
                                    root: classes.root,
                                    switchBase: classes.switchBase,
                                    thumb: classes.thumb,
                                    track: classes.track,
                                    checked: classes.checked,
                                }}
                            />
                        </Grid>
                    </Grid>

                    <Grid container className={classes.settingOptions}>
                        <Grid md={6} lg={6} sm={6}>
                            <p>Send Reminder for Expiration Date </p>
                        </Grid>
                        <Grid md={6} lg={6} sm={6} className="align-right">
                            <Switch
                                disabled={true}
                                checked={state.sendExpiryReminders ? state.sendExpiryReminders:true}
                                onChange={handleChange}
                                name="sendExpiryReminders"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                classes={{
                                    root: classes.root,
                                    switchBase: classes.switchBase,
                                    thumb: classes.thumb,
                                    track: classes.track,
                                    checked: classes.checked,
                                }}
                            />
                        </Grid>
                        <Grid container>
                            <Grid md={6} lg={6} sm={6}>
                                <div className="d-flex tab-6 flexWrap">
                                    <p className="align-right">Remind before</p>
                                    <div className={classes.remindMe}>
                                        <InputBaseField
                                            value={(state.reminderDays && state.reminderDays > 0) ? state.reminderDays:'5'}
                                            name="reminderDays"
                                            onChange={handleInputChange}
                                            type="text"
                                            onKeyPress={(e) => handleKeyPress(e)}
                                            MaxLength={1}
                                            IsDisabled={true}
                                        ></InputBaseField>
                                    </div>

                                    <p> Days </p>
                                </div>
                            </Grid>
                        </Grid>


                    </Grid>

                    <Grid container className={classes.settingOptions}>
                        <Grid md={6} lg={6} sm={6}>
                            <p>Notify when new offers are available </p>
                        </Grid>
                        <Grid md={6} lg={6} sm={6} className="align-right">
                            <Switch
                                checked={state.sendNewOffers ? state.sendNewOffers : true}
                                onChange={handleChange}
                                name="sendNewOffers"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                classes={{
                                    root: classes.root,
                                    switchBase: classes.switchBase,
                                    thumb: classes.thumb,
                                    track: classes.track,
                                    checked: classes.checked,
                                }}
                            />
                        </Grid>
                    </Grid>

                    <h3>Account Settings</h3>

                    <Grid container className={classes.settingOptions}>
                        <Grid md={6} lg={6} sm={6}>
                            <div className="d-flex flexWrap">
                                <p className="align-right">View Usage for Last</p>
                                <div className={classes.remindMe}>
                                    <InputBaseField
                                        type="number"
                                        value={state.usageMonths ? state.usageMonths:30}
                                        name="usageMonths"
                                        IsDisabled={true}
                                        onChange={handleInputChange}></InputBaseField>
                                </div>

                                <p> Months </p>
                            </div>
                        </Grid>
                    </Grid>


                    <Grid container className={classes.settingOptions}>
                        <Grid md={6} lg={6} sm={6}>
                            <div className="d-flex flexWrap">
                                <p className="align-right">Deactivate Line  if not used for </p>
                                <div className={classes.remindMe}>
                                    <InputBaseField
                                        type="text"
                                        value={state.daysBeforeDeactivation > 0 ? state.daysBeforeDeactivation:'30'}
                                        name="daysBeforeDeactivation"
                                        onChange={handleInputChange}
                                        MaxLength={2}
                                        onKeyPress={(e) => handleKeyPress(e)}
                                        IsDisabled={true}
                                    ></InputBaseField>
                                </div>

                                <p> Days </p>
                            </div>
                        </Grid>
                    </Grid>

                    <Grid container className={classes.settingOptions}>
                        <Grid md={6} lg={6} sm={6}>
                            <p>Enable Electronic Billing</p>
                        </Grid>
                        <Grid md={6} lg={6} sm={6} className="align-right">
                            <Switch
                                disabled={ true}
                                checked={state.electronicBillingDisable}
                                onChange={handleChange}
                                name="electronicBillingDisable"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                classes={{
                                    root: classes.root,
                                    switchBase: classes.switchBase,
                                    thumb: classes.thumb,
                                    track: classes.track,
                                    checked: classes.checked,
                                }}
                            />
                        </Grid>
                    </Grid>

                    <Grid container className={classes.formContaner}>
                        <div className={classes.footer}>
                            <div className={classes.footerRight}>
                                <Button className={classes.changeBtn} onClick={updateCustomerSetting}>Update</Button>
                            </div>

                        </div>
                    </Grid>




                </Grid>



            </Grid >


        </>
    )
}
export default withSnackbar(AccountSettings);